<template>
    <div>
        
        <div class="row no-gutters py-2 mt-3 company-form-container-warapper">
            <div class="ibox col-md-12 border-0">
                <div class="ibox-title dashboard_title company-form-box-title">
                    <h4 class="clearfix">
                        <span class="">Employees with Waived Provident Fund Profit
                            <span class="title-sub-text">
                            </span>
                        </span> 
                        <span class="float-right">
                            
                        </span>
                    </h4>
                </div>
                <div class="ibox-content pf-summery-data">
                    <div class="row py-3">
                        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 loan_approve_list  front_member_list">
                            <common-list  :is_approval_list="is_approval_list" :pageurl="this.$api_url" :is_action="0" :is_pf="is_n_pf" :checkbox="checkbox"  :appended_column="em_reg_appended_column" :key="em_reg_list_key" :company_options="em_reg_company_options" :employees="em_reg_custom_list" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key"></common-list>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
 
<script>

    export default{
        mounted() {
            //if(this.employeedata.last_working_day == '0000-00-00')
                //this.fdata.last_working_day = '';
            
            this.showoverlay = false;
        },
        props: ['pageurl' , 'flg'],
        components: {
        },
        data(){            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);
            return {
                     
                cu:window.location.href,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : true,
                pf_start_date : '',
                errormsg:[],
				hide:false,
                checkbox:0, 
                show_loader:true,
                pgurl:this.$api_url, 
                /* start pf signup variables */
                em_tmp_custom_list:[],
                min_date:minDate,

                /**Child Component property data */

                
                is_action:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                                /* Appended Column List  and there title and type */
                primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
   
                /***Child Component property data */

                /**Child Component property data */

                is_n_pf:1,
                    
                em_reg_appended_column:[                 
                    { value: "profit_waiver_from", text: "PF Profit Waived From",type: "date"},
                    { value: "profit_revive_from", text: "PF Profit Revived From",type: "date"},
                    // { value: "company_contribution", text: "Waived Employer Contribution",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    // { value: "employee_contribution", text: "Waived Employee Contribution",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "company_contribution", text: "Waived Employer Contribution",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "employee_contribution", text: "Waived Employee Contribution",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
               
                ],       
                em_reg_tmp_custom_list:[],
                em_reg_company_options:[],
                em_reg_custom_list:[],
                em_reg_list_key:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                em_reg_list_key:0,
                em_reg_primary_key:'id',
                em_reg_default_column:['name','email','jobposition','branch'], /* Default Column List */
                em_selected: [],
                selected: [],


                /***Child Component property data */
                curr_update_id:'',
                curr_approve_date:'',
                curr_update_employee:'',

                
            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('DD/MM/YYYY');
            },
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
      
            /*start pf signup functions*/


        exportUpdatetPF: function(sltd='')
        {
            
            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });
            console.log(this.em_selected);

            this.showoverlay = true;
            let formData = new FormData();
            if(sltd.length>0 && this.em_selected)
            formData.append('ids', this.em_selected);
            
            axios.post(this.$api_url+'/pf/waiver/export', formData)
            .then(function (response) 
            {                 
                this.showoverlay = false;                                                   
                //window.open(response.data);
                var fileURL = response.data;
                this.download_file(fileURL);
                
            }.bind(this))
            .catch(function (error) 
            {
                currentObj.errormsg = error.response.data.errors;
            });

        },


        download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },

            pfGetRegisteredEmployees: function()
            {
                let currentObj = this;
                currentObj.show_loader = true;
                axios.get(this.$api_url+'/pf/waiver/list' , {
     
                }).then(function(response){

                    
                this.em_reg_custom_list = [];



                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */ 
                    this.em_reg_tmp_custom_list = response.data.employee_data;
                    /* Assingning the list */ 
                    this.em_tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                }
                if (typeof response.data.options !== 'undefined')
                {
                    /* Assingning the Options */ 
                    this.em_reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                }
                


                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                
                if(this.em_tmp_custom_list.length > 0 )
                {
                    this.em_tmp_custom_list.forEach(element => {
                            if(element.employee_id > 0)
                            {
                                element.company_contribution = this.formatMoney(element.company_contribution);
                                element.employee_contribution = this.formatMoney(element.employee_contribution);

                                if(element.profit_waiver_from == '0000-00-00')
                                {
                                    element.profit_waiver_from = '';
                                }
                                if(element.profit_revive_from == '0000-00-00')
                                {
                                    element.profit_revive_from = '';
                                }
                            }
                        });


                this.em_reg_custom_list = this.em_tmp_custom_list;
                
                if(this.em_reg_custom_list.length > 0)
                {
                 
                    
                }
            }
            else
            {
                this.blankmsg = "No employee found as leaver";
            }
            
            
            this.em_reg_list_key = this.list_key + 1;
            currentObj.show_loader = false;
            
            }.bind(this)).catch(function (error){
                currentObj.show_loader = false;
                console.log(error);
                currentObj.serverError(error);
                
                });
            },

            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     { 
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // }, 
            

            

        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();
            this.pfGetRegisteredEmployees();
        } 
    }
</script> 
